// Vendor imports
const _ = require('lodash')
const classNames = require('classnames')
const PropTypes = require('prop-types')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('ToggleButton')

function ToggleButton(props) {
  let { checked, disabled, onChange, pending, readOnly } = props

  // Allow this component to be used as an "uncontrolled" input
  // https://reactjs.org/docs/uncontrolled-components.html
  const [
    uncontrolledChecked,
    setUncontrolledChecked
  ] = React.useState(props.defaultChecked)
  if (!onChange && !_.isBoolean(checked)) {
    checked = uncontrolledChecked
    onChange = () => {
      setUncontrolledChecked(!uncontrolledChecked)
    }
  }

  // Support keyboard focus visual indicator
  const [focus, setFocus] = React.useState(false)
  const onFocus = () => setFocus(true)
  const onBlur = () => setFocus(false)

  // Prevent changes while in pending/disabled state
  if (disabled || pending) {
    onChange = null
    readOnly = !disabled
  }

  const onClick = event => {
    /**
     * Work-around for weird browser-specific behavior:
     * For some reason, Chrome does not fire an `onChange`
     * event when the input is clicked, but DOES fire both
     * `onClick` and `onChange` events for keyboard interaction.
     */
    if (onChange && event.target.tagName !== 'INPUT') {
      onChange(event)
    }
  }

  return (
    tag('div', {
      className: classNames(
        props.className,
        bem.block({
          checked,
          disabled,
          pending,
          focus
        })
      ),
      onClick
    },
      tag('input', {
        className: bem.element('input'),
        checked,
        disabled,
        name: props.name,
        readOnly,
        title: props.title,
        type: 'checkbox',
        onChange,
        onFocus,
        onBlur
      })
    )
  )
}

ToggleButton.propTypes = {
  // Values
  checked: PropTypes.bool,
  className: PropTypes.string,
  defaultChecked: PropTypes.bool,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  pending: PropTypes.bool,
  readOnly: PropTypes.bool,
  title: PropTypes.string,
  // Callbacks
  onChange: PropTypes.func
}

module.exports = ToggleButton
